import { gql } from 'apollo-angular';

export const ReorderActivityDocument = gql(/* GraphQL*/ `mutation reorderActivity($activityId: Int!, $position: Int!) {
  reorderActivity(activityId: $activityId, position: $position) {
    id
  }
}
`);
